import styled from 'styled-components';

import { isChildcareReference, isCleaningReference, isWellnessReference } from '@wecasa/common/src/utils/universes';

import { getUniverseRef } from '@wecasa/customer/src/ducks/basket-selectors';

import { translate } from '@wecasa/i18n';

import { ModalContent } from '@wecasa/web-ui/src/components/modal/modal';

import { useAppSelector } from '../../store';
import Basket from '../basket/basket';
import BasketModal from './basket-modal';
import ChildcarePreview from './preview/childcare-preview';
import CleaningPreview from './preview/cleaning-preview';
import WellnessPreview from './preview/wellness-preview';

const t = translate('containers.basket');

const Wrapper = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  cursor: pointer;
`;

type MobileBasketProps = {
  isModalVisible: boolean;
  toggleModal: () => void;
  navigationContainerHeight: number;
  pathname: string;
};

export const MobileBasket = ({
  isModalVisible,
  toggleModal,
  navigationContainerHeight,
  pathname,
}: MobileBasketProps) => {
  const universeReference = useAppSelector(getUniverseRef);

  return (
    <>
      <BasketModal
        isOpen={isModalVisible}
        onClose={toggleModal}
        navigationContainerHeight={navigationContainerHeight}
        title={t('.my_basket')}
      >
        <ModalContent>
          <Basket pathname={pathname} />
        </ModalContent>
      </BasketModal>
      <Wrapper onClick={toggleModal} aria-label={t('.label')}>
        {isCleaningReference(universeReference) && <CleaningPreview />}
        {isWellnessReference(universeReference) && <WellnessPreview />}
        {isChildcareReference(universeReference) && <ChildcarePreview />}
      </Wrapper>
    </>
  );
};

export default MobileBasket;
